export function pushEventToDataLayer(actionName: string, userId: string | null = null) {
    eventToDataLayer(actionName, "onboarding_ui_event", userId);
}

export function pushLoginEventToDataLayer(actionName: string) {
    eventToDataLayer(actionName, "onboarding_ui_login_event");
}

function eventToDataLayer(actionName: string, eventName: string, userId: string | null = null) {
    window.dataLayer = window.dataLayer || [];
    const eventPayload: { event: string; action_name: string; user_id?: string } = {
        event: eventName,
        action_name: actionName,
    };
    if (userId) {
        eventPayload.user_id = userId;
    }
    window.dataLayer.push(eventPayload);
}
